"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var LockIcon_1 = require("../Icons/LockIcon");
var propTypes = {
    children: PropTypes.node
};
/**
 * The `FormFooter` component should be placed at the end of a form.
 */
var FormFooter = /** @class */ (function (_super) {
    __extends(FormFooter, _super);
    function FormFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormFooter.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement("p", { className: "ee_form-footer" }, React.Children.count(children) > 0 ? (children) : (React.createElement("span", { className: "ee_form-footer__content" },
            React.createElement(LockIcon_1.default, { width: 12, height: 12, className: "ee_form-footer__icon" }),
            "Ihre Daten werden zu Ihrer Sicherheit immer SSL-verschl\u00FCsselt \u00FCbertragen."))));
    };
    FormFooter.propTypes = propTypes;
    FormFooter.defaultProps = {
        children: undefined
    };
    return FormFooter;
}(react_1.Component));
exports.FormFooter = FormFooter;
exports.default = FormFooter;
//# sourceMappingURL=FormFooter.js.map
